var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoTemplates({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 150,
    viewBox: "0 0 140 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 139.563C108.66 139.563 140 108.32 140 69.7813C140 31.2421 108.66 0 70 0C31.3401 0 0 31.2421 0 69.7813C0 108.32 31.3401 139.563 70 139.563Z",
    fill: "url(#paint0_linear_22948_45255)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_22948_45255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.133 40.0039H29.8659C27.2886 40.0039 25.1992 42.0867 25.1992 44.656L25.1992 142.35C25.1992 144.919 27.2886 147.002 29.8659 147.002H110.133C112.71 147.002 114.799 144.919 114.799 142.35L114.799 44.656C114.799 42.0867 112.71 40.0039 110.133 40.0039Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6682 53.9609H36.4016C34.8552 53.9609 33.6016 55.2106 33.6016 56.7522C33.6016 58.2938 34.8552 59.5434 36.4016 59.5434H60.6682C62.2146 59.5434 63.4682 58.2938 63.4682 56.7522C63.4682 55.2106 62.2146 53.9609 60.6682 53.9609Z",
    fill: "#DEDFE3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4682 66.0547H36.4016C34.8552 66.0547 33.6016 67.3044 33.6016 68.8459C33.6016 70.3875 34.8552 71.6372 36.4016 71.6372H77.4682C79.0146 71.6372 80.2682 70.3875 80.2682 68.8459C80.2682 67.3044 79.0146 66.0547 77.4682 66.0547Z",
    fill: "#F4F4F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6682 79.0859H36.4016C34.8552 79.0859 33.6016 80.3356 33.6016 81.8772C33.6016 83.4188 34.8552 84.6684 36.4016 84.6684H60.6682C62.2146 84.6684 63.4682 83.4188 63.4682 81.8772C63.4682 80.3356 62.2146 79.0859 60.6682 79.0859Z",
    fill: "#DEDFE3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4682 91.1875H36.4016C34.8552 91.1875 33.6016 92.4372 33.6016 93.9788C33.6016 95.5203 34.8552 96.77 36.4016 96.77H77.4682C79.0146 96.77 80.2682 95.5203 80.2682 93.9788C80.2682 92.4372 79.0146 91.1875 77.4682 91.1875Z",
    fill: "#F4F4F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6682 104.215H36.4016C34.8552 104.215 33.6016 105.465 33.6016 107.006C33.6016 108.548 34.8552 109.797 36.4016 109.797H60.6682C62.2146 109.797 63.4682 108.548 63.4682 107.006C63.4682 105.465 62.2146 104.215 60.6682 104.215Z",
    fill: "#DEDFE3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4682 116.309H36.4016C34.8552 116.309 33.6016 117.558 33.6016 119.1C33.6016 120.641 34.8552 121.891 36.4016 121.891H77.4682C79.0146 121.891 80.2682 120.641 80.2682 119.1C80.2682 117.558 79.0146 116.309 77.4682 116.309Z",
    fill: "#F4F4F5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_22948_45255",
    x: 19.1992,
    y: 31.0039,
    width: 101.6,
    height: 118.996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22948_45255"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22948_45255",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22948_45255",
    x1: 70,
    y1: 0,
    x2: 70,
    y2: 139.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAECF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAECF0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTemplates);
export default __webpack_public_path__ + "static/media/no-templates.1bec6ba4cc9dc5eb33e795a97761a91f.svg";
export { ForwardRef as ReactComponent };